import { useContext } from '../Context'
import { useMongoSort } from '../../hooks/useMongoSort'
import React from 'react'
import { SortButton } from './SortButton'

export const MongoSortButton = () => {
  const { onSort, commonFields } = useContext()
  const sortFields = commonFields.sortFields

  const sortFunc = useMongoSort({ onSort, sortFields })
  return <SortButton onSort={sortFunc} />
}
